import React from "react";
import { Route, Switch } from "react-router-dom";
import Spinner from "../components/Spinner";
import ApiKeyPage from "../containers/ApiKeyPage";
import NotFound from "../containers/NotFound";
import {
    AcceptInvitationContainer,
    AppsContainer,
    InvitationsContainer,
    MembersContainer,
    SubscriptionsContainer,
    WelcomeContainer,
    WorkspaceContainer,
} from "../util/helpers/lazyLoader";

export const AuthenticatedRoutes = () => {
    return (
        <Switch>
            <Route path="/" exact component={AcceptInvitationContainer} />
            <Route path="/welcome" exact component={WelcomeContainer} />
            <Route path="/apps" exact component={AppsContainer} />
            <Route
                path="/subscriptions"
                exact
                component={SubscriptionsContainer}
            />
            <Route path="/team_members" exact component={MembersContainer} />
            <Route path="/workspace" exact component={WorkspaceContainer} />
            <Route path="/invitations" exact component={InvitationsContainer} />
            <Route path="/api-key" exact component={ApiKeyPage} />
            <Route component={() => <NotFound redirect_pathname="/" />} />
        </Switch>
    );
};

export const UnauthenticatedRoutes = ({ isLoggedIn }) => {
    return (
        <Switch>
            <Route
                path="/"
                exact
                component={() => {
                    if (!isLoggedIn)
                        return <NotFound redirect_pathname="/auth" />;
                    return <Spinner />;
                }}
            />
            <Route
                path="/auth"
                exact
                component={() => {
                    window.location.href =
                        window?.account?.API_HOST + "/oidc/authenticate/";
                    return null;
                }}
            />
            <Route component={() => <NotFound redirect_pathname="/" />} />
        </Switch>
    );
};
